<template>
  <div>
    <div class="human-data__block human-data__retreat">
      <div class="a-input-group a-input-group--human-data">
        <p class="a-label" v-t="'labels.email'">:</p>
        <p class="a-input a-input--disabled">
          {{currentEmail}}
          <span class="human-data__answer-good" v-if="currentEmail == user.email.verified">
                <img src="@/assets/img/static/b-icon_ticks.svg" alt="">
                {{$t('labels.verified')}}
              </span>
          <span class="human-data__answer-bad" v-else>
                {{$t('labels.unverified')}}
              </span>
        </p>
      </div>
    </div>
    <div class="human-data__block human-data__retreat">
      <div class="a-input-group a-input-group--human-data">
        <p class="a-label" v-t="'labels.phone-short'">:</p>
        <p class="a-input a-input--disabled">
          {{currentPhone}}
          <span class="human-data__answer-good" v-if="currentPhone == user.phone.verified">
                <img src="@/assets/img/static/b-icon_ticks.svg" alt="">
                {{$t('labels.verified')}}
            </span>
          <span class="human-data__answer-bad" v-else>
                {{$t('labels.unverified')}}
            </span>
        </p>
      </div>
    </div>
    <div class="human-data__block">
      <div class="a-label human-data__fio-label" v-t="'labels.username'">:</div>
      <p class="a-input a-input--disabled">{{user | fullName}}</p>
    </div>

    <div class="human-data__block" v-if="permissions.CAN_SET_DEPARTMENT">
      <div class="a-label " v-t="'labels.department'">:</div>
      <p class="a-input a-input--disabled">{{user.department.name}}</p>
    </div>

    <template v-if="permissions.IS_MTS_USER">
      <div class="human-data__block">
        <div class="a-label ">Роль:</div>
        <dropdown-new class="select-w-380" v-model="role" @change="onRoleChanged">
          <option :value="enums.UserRole.COMMISSION_MEMBER_NONE">Не установлена</option>
          <option :value="enums.UserRole.ORGANIZER" v-t="'user-role.organizer'"></option>
          <option :value="enums.UserRole.MAIN_ORGANIZER" v-t="'user-role.main-organizer'"></option>
        </dropdown-new>
      </div>

      <div class="human-data__block">
        <div class="a-label">Член комиссии:</div>
        <div class="a-checkbox">
          <label class="a-checkbox__label" :class="{'a-checkbox--disable': !canChangeInComission}">
            <input class="a-checkbox__input"
                   type="checkbox"
                   :disabled="!canChangeInComission"
                   v-model="inCommission">
            <span class="a-checkbox__icon"></span>
            <span class="a-checkbox__text"></span>
          </label>
        </div>
      </div>

      <div class="human-data__block" v-if="canChangeOwnerOfSubordinates">
        <div class="a-label ">ФИО Главного пользователя для починенных:</div>
        <dropdown-new class="select-w-380"
                      :options="mainUsers"
                      v-model="subordinatesOwner"></dropdown-new>
      </div>
      <div class="human-data__block" v-else-if="canChangeOwner">
        <div class="a-label ">{{$t('labels.fullname-of-main-user')}}:</div>
        <dropdown-new class="select-w-380"
                      :options="mainUsers"
                      v-model="owner"></dropdown-new>
      </div>
    </template>
    <template v-else-if="permissions.IS_CUSTOMER_USER">
      <div class="human-data__block" >
        <div class="a-label ">{{$t('labels.fullname-of-main-user')}}:</div>
        <dropdown-new class="select-w-380" :options="mainUsers" v-model="owner"></dropdown-new>
      </div>
    </template>

    <div class="human-data__block">
      <div class="a-label " v-t="'labels.passport-series-and-number'">:</div>
      <p class="a-input a-input--disabled">{{user.passport.series}} {{user.passport.id}}</p>
    </div>
    <div class="human-data__block human-data__block--rows" v-if="!permissions.CANNOT_SET_CATEGORIES">
      <div class="a-label " v-t="'labels.categories'">:</div>
      <div class="a-input a-input--disabled">
        {{categories | shortList(categoriesLimit)}}
        <span v-if="categoriesLimit == 0 || categories.length > categoriesLimit">
            <button v-if="categoriesLimit" class="gui-btn gui-btn--textarea" type="button" data-toggle="collapse" data-target="#textarea" @click="categoriesLimit = 0">Развернуть</button>
            <button v-else class="gui-btn gui-btn--textarea" type="button" data-toggle="collapse" data-target="#textarea" @click="categoriesLimit = 2">Свернуть</button>
          </span>
      </div>
    </div>

    <div class="human-data__block">
      <div class="a-label " v-t="'labels.status'">:</div>
      <p class="a-input a-input--disabled">{{$t(user.state.label)}}</p>
    </div>
    <div class="human-data__block">
      <div class="a-label " v-t="'labels.registration-date'">:</div>
      <date-time class="a-input a-input--disabled" :value="user.registrationTimestamp" :time="false"></date-time>
    </div>
    <div class="human-data__block">
      <div class="a-label " v-t="'labels.personal-data-last-change-date'">:</div>
      <date-time class="a-input a-input--disabled" :value="user.lastChangeTimestamp" :time="false"></date-time>
    </div>
    <div class="human-data__block">
      <div class="a-label " v-t="'labels.last-visit-date'">{{$t('labels.last-visit-date')}}:</div>
      <p class="a-input a-input--disabled">
        <date-time tag="span" :value="user.lastLoginTimestamp"></date-time>
        <span>, IP {{user.lastLoginIp}}</span>
      </p>
    </div>

    <div class="admin-buy__block-gui-btn a-flex-start">
      <template v-if="permissions.IS_MTS_USER && changed.flag">
        <button class="gui-btn gui-btn--red gui-btn--w-140" @click.prevent="onSaveUserInfoClick" v-t="'buttons.save'"></button>
        <button class="gui-btn gui-btn--white-border gui-btn--w-140" @click.prevent="onCancelOwnerChangeClick" v-t="'buttons.cancel'"></button>
      </template>
      <template v-else-if="changed.owner">
        <button class="gui-btn gui-btn--red gui-btn--w-140" @click.prevent="onSaveOwnerClick" v-t="'buttons.save'"></button>
        <button class="gui-btn gui-btn--white-border gui-btn--w-140" @click.prevent="onCancelOwnerChangeClick" v-t="'buttons.cancel'"></button>
      </template>

      <button class="gui-btn gui-btn--red gui-btn--w-184"
              @click.prevent="onBlockUserClick"
              v-t="'buttons.block-user'"
              v-if="user.permissions.CAN_BE_BLOCKED">
      </button>

      <button class="gui-btn gui-btn--red gui-btn--w-184"
              @click.prevent="onUnblockUserClick"
              v-t="'buttons.unblock-user'"
              v-if="user.permissions.CAN_BE_UNBLOCKED">
      </button>

      <button class="gui-btn gui-btn--white-border gui-btn--w-184"
              @click.prevent="onArchiveUserClick"
              v-t="'buttons.delete-user'"
              v-if="user.permissions.CAN_BE_ARCHIVED">
      </button>
    </div>

    <confirmation-dialog ref="confirmation"
                         @confirm="doOnConfirm"
                         @cancel="$refs.confirmation.close()">
    </confirmation-dialog>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { required, requiredIf } from '@/validators'

  import ConfirmationDialog from '@/components/common/dialogs/ConfirmationDialog'

  export default {
    components: {
      ConfirmationDialog
    },

    props: {
      profile: Object
    },

    data: () => ({
      categoriesLimit: 3,
      onConfirm: undefined,
      owner: undefined,
      subordinatesOwner: undefined,
      inCommission: undefined,
      role: undefined
    }),

    watch: {
      user() {
        this.owner = _.cloneDeep(this.user.parent);
        this.role  = _.cloneDeep(this.user.role);
        this.inCommission = this.user.inCommission;
      }
    },

    computed: {
      user() {
        return this.profile
      },

      currentEmail() { return this.user.email.unverified || this.user.email.verified },
      currentPhone() { return this.user.phone.unverified || this.user.phone.verified },
      permissions() { return this.user.permissions },

      categories() {
        return (this.user.categories || []).map(c => c.name);
      },

      canChangeInComission() {
        //return this.role.valueOf() !== this.enums.UserRole.COMMISSION_MEMBER_NONE;
        return true;
      },

      canChangeOwner() {
        return this.role.valueOf() !== this.enums.UserRole.MAIN_ORGANIZER;
      },

      canChangeOwnerOfSubordinates() {
        return this.role.valueOf() !== this.enums.UserRole.MAIN_ORGANIZER
            && this.user.role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER;
      },

      changed() {
        return {
          owner: (this.owner && this.owner != this.user.parent),
          flag: (this.owner && this.owner != this.user.parent) ||
                (this.role && this.role.valueOf() !== this.user.role.valueOf()) ||
                (this.inCommission !== undefined && this.inCommission !== this.user.inCommission)
         }
      },

      mainUsers() {
        const users = this.$store.getters.organizationUsers(this.user.organizationId);

        return users.filter(e => e.role.MAIN_ORGANIZER).map(v => {
          return {
            id: v.id,
            name: this.$options.filters.fullName(v)
          }
        })
      }
    },

    // validations: {
    //   role: {
    //     required,
    //     valid: function() {
    //
    //     }
    //   }
    // },

    methods: {
      onCancelOwnerChangeClick() {
        this.owner = _.cloneDeep(this.user.parent);
        this.role = _.cloneDeep(this.user.role);
        this.inCommission = this.user.inCommission;
      },

      onRoleChanged() {
        // if (this.user.role.valueOf() === this.role.valueOf()) return;
        //
        // if (this.role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER) {
        //   debugger
        //   this.owner = this.user.id;
        // }
        // else if (this.role.valueOf() === this.enums.UserRole.ORGANIZER) {
        //   // admin should choose new main org for current user
        // }
        // else {
        //   this.inCommission = true;
        //
        //   if (this.user.role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER) {
        //     // admin should choose new main org for subordinates
        //   }
        //   else {
        //     this.owner = undefined;
        //   }
        // }
      },

      async doOnConfirm() {
        await this.onConfirm();
      },

      onSaveOwnerClick() {
        this.onConfirm = async () => {
          await this.saveOwner();
        };

        this.$refs.confirmation.open({
          title: 'Смена подчинения',
          text: 'Вы уверены что хотите сменить подчинение пользователя?'
        });
      },

      onSaveUserInfoClick() {
        // this.$v.$touch();
        // if (this.$v.$invalid) return;

        this.saveUserInfo();
      },

      onBlockUserClick() {
        this.onConfirm = async () => {
          await this.blockUser();
        };

        this.$refs.confirmation.open({
          title: 'Блокирование пользователя',
          text: 'Вы уверены что хотите заблокировать пользователя?'
        });
      },

      onUnblockUserClick() {
        this.onConfirm = async () => {
          await this.unblockUser();
        };

        this.$refs.confirmation.open({
          title: 'Разблокирование пользователя',
          text: 'Вы уверены что хотите разблокировать пользователя?'
        });
      },

      onArchiveUserClick() {
        this.onConfirm = async () => {
          await this.archiveUser();
        };

        this.runBlockerAction(async() => {
          try {
            const isLastUser = await this.$store.dispatch('isLastUser', {
              userId: this.user.id
            });

            this.$refs.confirmation.open({
              title: 'Удаление пользователя',
              text: isLastUser ? 'Вы уверены что хотите удалить последнего пользователя у контрагента? Вместе с этим пользователем будет удален и контрагент': 'Вы уверены что хотите удалить пользователя?'
            });
          }
          catch(e) {
            console.error('unable to check if user is the last', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async saveOwner() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('changeMainUser', {
              userId: this.user.id,
              ownerId: this.owner
            });

            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to change a department of user', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async saveUserInfo() {
        this.runBlockerAction(async () => {
          try {
            let owner = 0;

            if (this.role.valueOf() === this.enums.UserRole.MAIN_ORGANIZER) {
              owner = this.user.id;
            }
            else if (this.canChangeOwnerOfSubordinates) {
              owner = this.subordinatesOwner;
            }
            else if (this.canChangeOwner) {
              owner = this.owner;
            }

            await this.$store.dispatch('changeCustomerUserInfo', {
              userId: this.user.id,
              role: this.role.valueOf(),
              mainUserId: owner,
              inCommission: !!this.inCommission
            });
          }
          catch(e) {
            console.error('unable to change a department of user', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async blockUser() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('blockUser', this.user);
            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to block user', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async unblockUser() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('unblockUser', this.user);
            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to unblock user', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async archiveUser() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('archiveUser', this.user);
            this.$refs.confirmation.close();
          }
          catch(e) {
            console.error('unable to archive user', e);
            this.globalErrorHandler(e);
          }
        });
      },

      async onOwnerSearching({ text, done}) {
        let result = await this.$store.dispatch('searchOwner', text);

        done((result || []).map(e => ({
          id: e.id,
          text: e.name
        })));
      },
    }
  }
</script>

<style scoped>

</style>
